// src/components/ScrollToTop.jsx
import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

const ScrollToTop = ({ location }) => {
  useEffect(() => {
    // Reset the scrollable <main>
    const container = document.querySelector("[data-scroll-container]");
    if (container) {
      container.scrollTop = 0;
    } else {
      // fallback to window
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return null;
}

export default withRouter(ScrollToTop);